import {
SET_AVAILABLE_POLICIES
} from "../actions/types";

const initialState = {
  availablePolicies: [],
};

export default function timeoffReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AVAILABLE_POLICIES:
      return {
        ...state,
        availablePolicies: action.payload,
      };
    default:
      return state;
  }
} 